import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabPane, Menu, Table, TableHeader, TableRow, TableHeaderCell, TableCell, TableBody, Button, Form, Segment, Header, Icon, SegmentInline } from "semantic-ui-react";
import { useQuery } from "react-query";
import UserTableRow from "./UserTableRow";
import { getWeeklySchedule } from "../queries";
import "./UserTable.css";

const UserTableContainer = () => {
    const { t, i18n } = useTranslation();
    const [gotData, setGotData] = useState(false)

    const {
        data,
        error, 
        isLoading,
        refetch: refetchTable,
    } = useQuery("getWeeklySchedule", getWeeklySchedule, {
        onSettled: (response) => {
            if (!gotData){
                setGotData(true);
                setActiveIndex(getDefaultActiveIndex(response))
            }
        }
    });

    const getDefaultActiveIndex = (data) => {
        let d = new Date().getDay();
        if (d >= 5) return 0;
        if (data){
            if (Object.keys(data).length < 5-d) return d+1;
        }
        return d;
    };
    
    const [activeIndex, setActiveIndex] = useState(getDefaultActiveIndex(data));

    return (
    <>
    <Header size="large" textAlign="center">{t("appointment-schedule-page")}</Header>
    <Tab 
        activeIndex={activeIndex}
        onTabChange={(_, { activeIndex: i }) => setActiveIndex(i)}
        panes={['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'].map((day, index) => ({
            pane: day,
            menuItem: <Menu.Item key={day} disabled={index < getDefaultActiveIndex(data)}>{t(day)}</Menu.Item>, 
            render: () => (
                <TabPane
                    loading={isLoading}
                    content={(data && data[day]) ? (
                        <div style={{ overflowY: 'scroll', maxHeight: 500 }}>
                            <Table striped definition celled collapsing unstackable textAlign="center" style={{ width: '100%' }}>
                                <TableHeader>
                                    <TableRow>
                                        <TableHeaderCell>{t('time')}</TableHeaderCell>
                                        <TableHeaderCell>{t('name')}</TableHeaderCell>
                                        <TableHeaderCell>{t('course')}</TableHeaderCell>
                                        <TableHeaderCell>{t('notes')}</TableHeaderCell>
                                        <TableHeaderCell>{t('Action')}</TableHeaderCell>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {data[day].map((appointment) => (
                                        <React.Fragment key={`${day}${appointment.start_time}`}>
                                            <UserTableRow refetchTable={refetchTable} appointment={appointment} day={day} />
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    ) : (
                        <Segment placeholder>
                            <Header icon>
                                <Icon name='search' />
                                {t('no-data-for-this-day')}
                            </Header>
                        </Segment>
                    )}
                />
            ),
        }))}
    /></>);
}

export default UserTableContainer;